import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import { createRoot } from 'react-dom/client'
import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

import { setUpAnalytics } from 'utils/analytics'
import { isProductionApp } from './const'
import { setUpSentry } from './monitoring/sentry'
import ErrorBoundaryComponent from './website/ErrorBoundary'

const axeConfig = {
	rules: [{ id: 'color-contrast', enabled: false }],
}

if (import.meta.env.DEV) {
	import('@axe-core/react')
		.then(axe => {
			axe.default(React, ReactDOM, 1000, axeConfig)
		})
		.catch(() => {})
}

if (isProductionApp) {
	setUpAnalytics()
	setUpSentry()
}

// Browser tracing (#1662). Unset endpoint: Vite drops this branch and builds no OTel chunk. Sampled per page load,
// so unsampled tabs download and patch nothing; a missing or bad ratio samples 10%, as in smsl-backend.
if (import.meta.env.VITE_OTEL_TRACES_ENDPOINT) {
	const ratio = Number(import.meta.env.VITE_OTEL_SAMPLE_RATIO?.trim() || NaN)
	if (Math.random() < (ratio >= 0 && ratio <= 1 ? ratio : 0.1)) {
		import('./monitoring/otel').then(m => m.setUpOtel()).catch(() => {})
	}
}

const container = document.getElementById('root')!
const root = createRoot(container)
root.render(
	<div>
		<Suspense fallback={<div />}>
			{/* @ts-ignore */}
			<ErrorBoundaryComponent>
				<App />
			</ErrorBoundaryComponent>
		</Suspense>
	</div>,
)

serviceWorkerRegistration.unregister()
